import { createContext, type ReactNode, useMemo, use } from 'react'
import { type Facet, SearchType } from '@/features/shop/services/Search/types'

type FiltersContextType = { facets: Facet[]; searchType: SearchType } | undefined
const FiltersContext = createContext<FiltersContextType>(undefined)

type Props = { children: ReactNode; facets: Facet[]; searchType?: SearchType }

export const FiltersContextProvider = ({
  children,
  facets,
  searchType = SearchType.SEARCH,
}: Props) => {
  const value = useMemo(() => ({ facets, searchType }), [facets, searchType])
  return <FiltersContext value={value}>{children}</FiltersContext>
}

export const useFiltersContext = () => {
  const context = use(FiltersContext)

  if (context === undefined) {
    throw new Error('useFiltersContext must be used within a FiltersContextProvider')
  }
  return context
}
